export const stripHtml = (html?: string | null) => {
  if (!html) return '';

  return html
    .replace('&amp;', '&')
    .replace('&quot;', '"')
    .replace(/<[^>]*>?/gm, '');
};

// Trim string to a certain number of words
export const trimStr = (str: string | undefined, { maxWords, maxLength }: { maxWords?: number; maxLength?: number }) => {
  if (!str) return '';
  if (!maxWords && !maxLength) return str;
  let mod = str;
  if (maxWords && maxWords > 0) {
    const wordsCount = str.split(' ').length;
    if (wordsCount > maxWords) {
      mod = str.split(' ').splice(0, maxWords).join(' ');
    }
  }
  if (maxLength && maxLength > 0 && mod.length > maxLength) {
    mod = mod.slice(0, maxLength);
  }
  return mod !== str ? `${mod}...` : mod;
};

export const trimStrToSizeByWords = (str: string | undefined, maxLength: number): string => {
  if (!str) return '';
  if (!maxLength) return str;
  let mod = '';
  const words = str.split(' ');
  for (const word of words) {
    if (mod.length + word.length + 1 > maxLength) {
      break;
    }
    mod = `${mod} ${word}`;
  }
  return mod !== str ? `${mod}...` : mod;
};

// Remove html tags and line breaks
export const clearHtmlTagText = (text: string): string => {
  if (!text) return '';
  let mod = text;
  // Remove all line breaks
  mod = mod.replace(/(\r\n|\n|\r)/gm, '');
  // Remove html tags
  mod = mod.replace(/(<([^>]+)>)/gi, '');
  // Remove spaces before and after
  mod = mod.trim();
  return mod;
};

// Convert text to id
export const textToId = (text?: string | null): string => {
  if (!text) return '';
  let mod = text;
  // Remove html tags
  mod = mod.replace(/(<([^>]+)>)/gi, '');
  // Remove all not alphanumeric characters
  mod = mod.replace(/[^a-zA-Z0-9 ]/g, '');
  // Remove spaces before and after
  mod = mod.trim();
  // Replace spaces with dashes
  mod = mod.replace(/\s+/g, '-');
  // Convert to lowercase
  mod = mod.toLowerCase();
  return mod;
};

export const strToYouTubeId = (str: string): string | undefined => {
  const regExp = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/gi;
  const match = regExp.exec(str);
  return match ? match[1] : undefined;
};

// Calculate text reading time in minutes
export const getTextReadingTime = (text: string): number => {
  if (!text) return 0;
  const wordsPerMinute = 200;
  const noOfWords = text.split(/\s/g).length;
  const val = Math.ceil(noOfWords / wordsPerMinute);
  return val <= 0 ? 1 : val;
};
